import { IModal } from "config/types";
import { LOCATION_CHANGE } from "store/actions/router";

import { createReducer, PayloadAction } from "@reduxjs/toolkit";
import { defaultTo } from "lodash-es";

import { ModalMetaInput } from "../actions/modal";
import * as t from "../constants";

const defaultState = {
  currentModal: "",
  id: "",
  data: {} as Record<string, unknown>,
} satisfies IModal;

const modal = createReducer(defaultState, builder => {
  builder
    .addCase(t.SET_MODAL, (state, action) => {
      const payload = (action as PayloadAction<{ modal: string; data: ModalMetaInput }>).payload;
      const { id, ...rest } = payload.data;
      state.currentModal = payload.modal;
      state.data = defaultTo(rest, {});
      state.id = (id as string) ?? "";
    })
    .addCase(t.RESET_MODAL, () => defaultState)
    .addCase(LOCATION_CHANGE, () => defaultState);
});

export default modal;
